/**
 * Recruitment Routes Component
 *
 * Defines all routes for the Recrutamento module.
 */

import { Routes, Route } from 'react-router-dom';
import { CandidatosListPage } from '@/features/Recruitment/pages';

export default function RecruitmentRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CandidatosListPage />} />
    </Routes>
  );
}
